<template>
  <div class="block-additional-services">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text type=h4 bold class="block-additional-services__title">Дополнительные услуги</bim-text>
        <bim-text type=main class="mb-12 mt-9 block-additional-services__desc">Продвигайте ваш бренд благодаря приоритетному размещению на портале BIMLIB.</bim-text>

        <div class="d-flex services flex-column flex-lg-row">
          <div
            v-for="service of services"
            :key="service.title"
            class="services__item"
          >
            <img :src="service.img" alt="" height="240px" />
            <bim-text type=accent bold class="mt-10">{{ service.title }}</bim-text>
            <bim-text type=main class="mt-6 mb-9">{{ service.desc }}</bim-text>
            <div class="d-flex flex-column flex-sm-row">
              <bimButton
                class="mr-sm-6 mt-6 mt-sm-0 services__button order-3 order-sm-1"
                :label="$t('Заказать услугу')"
                @click="$emit('leaveRequest', `Заказ услуги '${service.title}'`)"
              />
              <bim-text
                class="d-flex align-center order-2"
                type=accent
                bold
              >
                {{ service.price }}
              </bim-text>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row advantages mt-12">
          <div
            v-for="advantage of advantages"
            :key="advantage.title"
            class="advantages__item d-flex align-center"
          >
            <img alt="" :src="advantage.img" class="mr-6" />
            <bim-text type=main bold>{{ advantage.title }}</bim-text>
          </div>
        </div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"
export default {
  inject: ["imgPath"],
  name: "BlockAdditionalServices",
  components: {
    bimButton,
    bimCol,
    bimContainer,
  },
  data() {
    return {
      services: [
        {
          title: this.$t("Написание уникальных авторских статей о ваших продуктах"),
          desc: this.$t("На языке инженера расскажем о вашей продукции и ее цифровых двойниках (BIM/AR моделях)."),
          img: `${this.imgPath}/landing-plans-2-4.svg`,
          price: this.$t("10 000 ₽ за статью "),
        },
        {
          title: this.$t("Электронная рассылка по базе проектировщиков"),
          desc: this.$t("Поместим ваши материалы в электронную рассылку по аудитории BIMLIB. Охват более 22000 проектировщиков."),
          img: `${this.imgPath}/landing-plans-2-5.svg`,
          price: this.$t("8 000 ₽ за рассылку "),
        },
      ],
      advantages: [
        {
          img: `${this.imgPath}/13.svg`,
          title: this.$t("Авторство")
        },
        {
          img: `${this.imgPath}/14.svg`,
          title: this.$t("Уникальный результат")
        },
        {
          img: `${this.imgPath}/15.svg`,
          title: this.$t("Продвижение")
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.block-additional-services {
  padding: 64px 0;
  background-color: #fafafa;

  .block-additional-services__title,
  .block-additional-services__desc {
    text-align: center;
    margin: auto;
  }

  .block-additional-services__title {
    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 32px;
      }
    }
  }

  .block-additional-services__desc {
    max-width: 600px;
  }
}

.services {

  .services__item {
    flex: 1 1 50%;

    &:first-child {
      margin-right: 32px;
    }

    @media screen and (max-width: $breakpoint-md) {
      &:first-child {
        margin-right: 0;
        margin-bottom: 32px;
      }
    }

    .services__button {
      height: auto;
      padding: 16px 28px;
      font-size: 14px;
      line-height: 1.36;
    }
  }
}

.advantages {
  .advantages__item {
    flex: 1 1 33.3333%;

    &:not(:last-child) {
      margin-right: 34px;
    }

    @media screen and (max-width: $breakpoint-md) {
      &:not(:last-child) {
        margin-right: 0;
        margin-bottom: 34px;
      }
    }
  }
}
</style>
